<template>
  <hr-form-dialog
    ref="dialog"
    size="md"
    :title="$t('sessions.noteTemplate.rejectRequest.title')"
    @hide="onDialogHide"
    @submit="onSubmit"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ $t('sessions.noteTemplate.rejectRequest.text') }}
      </p>
      <hr-text-field
        :model-value="rejectionReason"
        :label="$t('sessions.noteTemplate.changeRequest.inputReason')"
        :placeholder="$t('sessions.noteTemplate.rejectRequest.inputRejectReason')"
        :rules="rules.inputValidationRules"
        hide-bottom-space
        class="col-12"
        @update:model-value="onInputValue"
      />
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <universal-tooltip
        :show-tooltip="!rejectionReason.trim()"
        :text="$t('sessions.noteTemplate.rejectRequest.tooltipRejectReason')"
      >
        <hr-confirm-btn
          type="submit"
          :label="$t('common.buttonSubmit')"
          :disable="!rejectionReason.trim()"
        />
      </universal-tooltip>
    </template>
  </hr-form-dialog>
</template>
<script>

import UniversalTooltip from 'components/UI/UniversalTooltip.vue';
import {
  isEmpty,
} from 'lodash';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'ChangeRequestRejectModal',

  components: {
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
    HrTextField,
    UniversalTooltip,
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      rejectionReason: '',

      rules: {
        inputValidationRules: [
          (val) => {
            if (isEmpty(val.trim())) {
              return this.$t('sessions.noteTemplate.validateSessionNoteField');
            }
            return true;
          },
        ],
      },
    };
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    async onDialogHide() {
      this.$emit('hide');
    }, // onDialogHide()

    async onSubmit() {
      const changedRequestChanges = {
        status: 'rejected',
        rejectionReason: this.rejectionReason,
      };

      this.$emit('ok', changedRequestChanges);
      this.hide();
    }, // onSubmit()

    onInputValue(value) {
      this.rejectionReason = value;
    }, // onInputValue()

  },
};
</script>
